// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  --wrapper-gap: 0.5rem;
  height: 100%;
  display: grid;
  grid-template-rows: [header-start] auto [header-end content-start] 1fr [content-end];
  grid-template-columns: [sidebar-start] auto [sidebar-end content-start] 1fr [content-end];
}
.app-container > #sidebar {
  grid-area: header/sidebar/content;
}
.app-container > #header {
  grid-area: header/content/header/content;
}
.app-container > #progressbar {
  grid-area: content;
  height: 2px;
}
.app-container > #content {
  grid-area: content;
  display: grid;
  grid-template-rows: [full-start] var(--wrapper-gap) [content-start] 1fr [content-end full-end];
  grid-template-columns: [full-start] var(--wrapper-gap) [content-start] 1fr [content-end full-end];
  overflow: auto;
}
.app-container > #content > .wrapper {
  grid-area: full;
  display: grid;
  grid-template-rows: [actionbar-start] auto [actionbar-end content-start] 1fr [content-end];
  overflow: hidden;
}
.app-container > #content > .wrapper:not(.full) {
  grid-area: content;
}
.app-container > #content > .wrapper.background {
  box-shadow: var(--gc-box-shadow);
  background: var(--gc-background-color);
  border-radius: 3px;
  border: 1px solid var(--gc-border-color);
}
.app-container > #content > .wrapper > .action-bar {
  grid-row: actionbar;
  display: grid;
  grid-template-columns: [breadcrumbs-start] 1fr [breadcrumbs-end action-start] auto [action-end];
  gap: var(--wrapper-gap);
}
.app-container > #content > .wrapper > .action-bar .breadcrumbs {
  grid-column: breadcrumbs;
}
.app-container > #content > .wrapper > .action-bar .action {
  grid-column: action;
}

.toast-container {
  display: grid;
  grid-template-columns: [icon-start] min-content [icon-end message-start] 1fr [message-end];
  gap: 0.5rem;
  margin: 0;
}
.toast-container .p-toast-detail {
  margin: 0;
}
.toast-container > .icon {
  grid-column: icon;
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
}
.toast-container > .message {
  grid-column: message;
  max-height: 200px;
  overflow: auto;
}
.toast-container > .message .summary {
  font-weight: bold;
}
.toast-container > .action {
  grid-column: message;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(50% - 0.5rem), 1fr));
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.sass"],"names":[],"mappings":"AACA;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,oFAAA;EACA,yFAAA;AAAJ;AACI;EACI,iCAAA;AACR;AAAI;EACI,wCAAA;AAER;AADI;EACI,kBAAA;EACA,WAAA;AAGR;AAFI;EACI,kBAAA;EACA,aAAA;EACA,8FAAA;EACA,iGAAA;EACA,cAAA;AAIR;AAFQ;EACI,eAAA;EACA,aAAA;EACA,0FAAA;EACA,gBAAA;AAIZ;AAHY;EACI,kBAAA;AAKhB;AAJY;EACI,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,wCAAA;AAMhB;AALY;EACI,mBAAA;EACA,aAAA;EACA,+FAAA;EACA,uBAAA;AAOhB;AANgB;EACI,wBAAA;AAQpB;AAPgB;EACI,mBAAA;AASpB;;AANA;EACI,aAAA;EACA,0FAAA;EACA,WAAA;EACA,SAAA;AASJ;AARI;EACI,SAAA;AAUR;AATI;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAWR;AAVI;EACI,oBAAA;EACA,iBAAA;EACA,cAAA;AAYR;AAXQ;EACI,iBAAA;AAaZ;AAZI;EACI,oBAAA;EACA,aAAA;EACA,wEAAA;EACA,WAAA;AAcR","sourcesContent":["// more styling in src/theme/global.sass\n.app-container\n    --wrapper-gap: 0.5rem\n    height: 100%\n    display: grid\n    grid-template-rows: [header-start] auto [header-end content-start] 1fr [content-end]\n    grid-template-columns: [sidebar-start] auto [sidebar-end content-start] 1fr [content-end]\n    > #sidebar\n        grid-area: header/sidebar/content\n    > #header\n        grid-area: header/content/header/content\n    > #progressbar\n        grid-area: content\n        height: 2px\n    > #content\n        grid-area: content\n        display: grid\n        grid-template-rows: [full-start] var(--wrapper-gap) [content-start] 1fr [content-end full-end]\n        grid-template-columns: [full-start] var(--wrapper-gap) [content-start] 1fr [content-end full-end]\n        overflow: auto\n        \n        > .wrapper \n            grid-area: full\n            display: grid\n            grid-template-rows: [actionbar-start] auto [actionbar-end content-start] 1fr [content-end]\n            overflow: hidden\n            &:not(.full)\n                grid-area: content\n            &.background\n                box-shadow: var(--gc-box-shadow)\n                background: var(--gc-background-color)\n                border-radius: 3px\n                border: 1px solid var(--gc-border-color)\n            > .action-bar\n                grid-row: actionbar\n                display: grid\n                grid-template-columns: [breadcrumbs-start] 1fr [breadcrumbs-end action-start] auto [action-end]\n                gap: var(--wrapper-gap)\n                .breadcrumbs\n                    grid-column: breadcrumbs\n                .action\n                    grid-column: action\n\n\n.toast-container\n    display: grid\n    grid-template-columns: [icon-start] min-content [icon-end message-start] 1fr [message-end]\n    gap: 0.5rem\n    margin: 0\n    .p-toast-detail\n        margin: 0\n    > .icon\n        grid-column: icon\n        font-size: 2rem\n        height: 2rem\n        width: 2rem\n    > .message\n        grid-column: message\n        max-height: 200px\n        overflow: auto\n        .summary\n            font-weight: bold\n    > .action\n        grid-column: message\n        display: grid\n        grid-template-columns: repeat(auto-fit, minmax(calc(100%/2 - 0.5rem), 1fr))\n        gap: 0.5rem"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
